import React, { useEffect, useReducer } from 'react';
import { Loader } from 'pixi.js'
import { useHistory } from "react-router-dom";
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import Fab from '@material-ui/core/Fab';
import { ErrorBoundary } from 'react-error-boundary'

import HomeContext from '../../context/home-context';
import homeReducer from '../../reducers/home-reducer';
import { getGetMonsterDetailByStudentNumber } from '../../actions/monster-actions';
import { getIslandScores, getWeatherConditions, getIslandStatisticsByStudentNumber } from '../../actions/home-actions';

import ClusterModal from '../shared/modals/ClusterModal'
import IslandHolder from './IslandHolder'
import Loading from '../shared/Loading'
import IslandMenu from './IslandMenu';
import NotificationPopover from '../../components/notification/NotificationPopover'
import ErrorFallback from '../shared/ErrorFallback'

import { HowlerUtils } from '../../utils/helpers/island/SoundHelper'
import { StudentProfile } from '../../utils/services/cache/ClientCache'
import { InitLearning, InitMindset, InitWellbeing, InitResilience } from '../../utils/helpers/island/TraitIslandCreationHelper';
import { CalculateDailyChestLogic } from '../../utils/helpers/island/DailyChestClaimHelper';
import * as Weather from '../../utils/constants/WeatherConstants'
import { getStudentConsentSession, getStudentSelectClusterSession, getStudentNumberFromSession, setWeatherSession } from '../../utils/helpers/others/SessionHelper'

const HomeApp = () => {
    const history = useHistory();
    const [homeContext, dispatch] = useReducer(homeReducer);
    const [loading, setLoading] = React.useState(true);
    const [isMute, setIsMute] = React.useState(StudentProfile.getSoundMute() === 'true' ? true : false);
    const loader = Loader.shared; // PixiJS exposes a premade instance for you to use.

    let studentConsent = getStudentConsentSession();
    let selectCluster = getStudentSelectClusterSession();
    let currentTime = new Date().getHours();
    //let currentTime = 20;

    useEffect(() => {
        const initHome = async () => {
            if (isMute) {
                setIsMute(true);
                HowlerUtils.muteGlobalVolume();
                StudentProfile.setSoundMute(true);
            }
            addSpritesheetAssets();

            let response = await getIslandScores();
            if (response > 200 || response.status === "Failed") {
                return history.push("/SessionTimeOut")
            }
            if (response.status === "Success") {
                let islandScores = response.data;
                islandScores.forEach((value) => {
                    switch (value.traitGroupName) {
                        case "Approaches to Learning and Studying":
                            let learning = InitLearning(value);
                            dispatch({ type: 'SET_LEARNING', learning: learning });
                            break;
                        case "Mindset":
                            let mindset = InitMindset(value);
                            dispatch({ type: 'SET_MINDSET', mindset: mindset });
                            break;
                        case "Promotion of Well-being":
                            let wellbeing = InitWellbeing(value);
                            dispatch({ type: 'SET_WELLBEING', wellbeing: wellbeing });
                            break;
                        case "Grit and Resilience":
                            let resilience = InitResilience(value);
                            dispatch({ type: 'SET_RESILIENCE', resilience: resilience });
                            break;
                    }
                });
            }

            response = await getIslandStatisticsByStudentNumber(getStudentNumberFromSession());
            if (response > 200 || response.status === "Failed") {
                return history.push("/SessionTimeOut")
            }
            if (response.status === "Success") {
                //console.log("IslandStatics", response);
                let dailyChestClaim = CalculateDailyChestLogic(response.data);
                dispatch({ type: 'SET_DAILYCHESTCLAIM', dailyChestClaim: dailyChestClaim });
            }

            response = await getGetMonsterDetailByStudentNumber(getStudentNumberFromSession());
            if (response > 200 || response.status === "Failed") {
                return history.push("/SessionTimeOut")
            }
            if (response.status === "Success") {
                loadMonsterMenu(response);
            }

            response = await getWeatherConditions();
            loadWeatherCondition(response.condtion);
            loader.load(setup);
        };
        initHome();
        return () => loader.reset();
    }, []);

    // loader functions
    const addSpritesheetAssets = () => {
        //common graphic loading
        loader
            //foods
            .add("./assets/images/components/island/spritesheets/foods/chest_berry.json")
            .add("./assets/images/components/island/spritesheets/foods/chest_drumstick.json")
            .add("./assets/images/components/island/spritesheets/foods/berry.json")
            .add("./assets/images/components/island/spritesheets/foods/drumstick.json")
            //seaAssets
            .add("./assets/images/components/island/spritesheets/seaAssets/dolphin1.json")
            .add("./assets/images/components/island/spritesheets/seaAssets/dolphin2.json")
            .add("./assets/images/components/island/spritesheets/seaAssets/ferry.json")
            .add("./assets/images/components/island/spritesheets/seaAssets/sea_sparkle.json")
            .add("./assets/images/components/island/spritesheets/seaAssets/ship.json")
            .add("./assets/images/components/island/spritesheets/seaAssets/ship_ferry_extra.json")
            //skyAssets
            .add("./assets/images/components/island/spritesheets/skyAssets/challengeSmokeText.json")
            .add("./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json")
            .add("./assets/images/components/island/spritesheets/skyAssets/cloud.json")
            .add("./assets/images/components/island/spritesheets/skyAssets/skyAsset.json")
            //traits
            .add("./assets/images/components/island/spritesheets/traits/learning.json")
            .add("./assets/images/components/island/spritesheets/traits/mindset.json")
            .add("./assets/images/components/island/spritesheets/traits/wellbeing.json")
            .add("./assets/images/components/island/spritesheets/traits/resilience.json")
            //dayOfTheIsland
            .add("./assets/images/components/island/spritesheets/dayOfTheIsland/morningBG.json")
            .add("./assets/images/components/island/spritesheets/dayOfTheIsland/island_day.json")
            .add("./assets/images/components/island/spritesheets/dayOfTheIsland/afternoonBG.json")
            .add("./assets/images/components/island/spritesheets/dayOfTheIsland/eveningBG.json")
            //others
            .add("./assets/images/components/island/spritesheets/others/messages.json")

        if (currentTime > 19 || currentTime <= 4) {
            loader
                .add("./assets/images/components/island/spritesheets/dayOfTheIsland/island_night.json")
                .add("./assets/images/components/island/spritesheets/dayOfTheIsland/nightBG.json")
                .add("./assets/images/components/island/spritesheets/dayOfTheIsland/star1.json")
        }
    }

    const loadMonsterMenu = (response) => {
        let monsterMenu = {
            open: false,
            cluster: response.data.monsterCluster,
            monsterLvl: response.data.monsterLvl,
            moodMeter: response.data.moodMeter,
            feedCount: response.data.feedCount,
            isMissing: response.data.isMissing,
            messages: response.data.messages
        }
        //monster size
        switch (parseInt(response.data.monsterLvl)) {
            case 1:
                monsterMenu.monsterSize = { x: 0.3, y: 0.3 };
                break;
            case 2:
                monsterMenu.monsterSize = { x: 0.4, y: 0.4 };
                break;
            case 3:
                monsterMenu.monsterSize = { x: 0.5, y: 0.5 };
                break;
            case 4:
                monsterMenu.monsterSize = { x: 0.6, y: 0.6 };
                break;
        }
        // monster textures
        switch (response.data.monsterCluster) {
            case "HSS":
                //hss monster
                loader
                    .add("./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_walking.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_eating.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_jumping.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_reverse.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_standby.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_sad.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_reverse_walking.json")
                break;
            case "ICT":
                //hss monster
                loader
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_walking.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_eating.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_jumping.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_reverse_walking.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_sad.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_standby.json")
                break;
            case "CEFT":
                //ceft monster
                loader
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_walking.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_eating.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_jumping.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_reverse_walking.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_sad.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_standby.json")
                break;
            case "DSB":
                //dsb monster
                loader
                    .add("./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_walking.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_eating.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_jumping.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_reverse_walking.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_sad.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_standby.json")
                break;
            case "ENG":
                //engineering monster
                loader
                    .add("./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_walking.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_eating.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_jumping.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_reverse_walking.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_sad.json")
                    .add("./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_standby.json")
                break;
        }
        dispatch({ type: 'SET_MONSTER_MENU', monsterMenu: monsterMenu });
    }

    const loadWeatherCondition = (response) => {
        switch (response) {
            case Weather.HEAVY_THUNDERY_SHOWERS_WITH_GUSTY_WINDS:
            case Weather.HEAVY_THUNDERY_SHOWERS:
            case Weather.THUNDER_SHOWERS:
                loader.add("./assets/images/components/island/spritesheets/skyAssets/lightning.json")
                loader.add("./assets/images/components/island/spritesheets/dayOfTheIsland/rainingBG.json")
                dispatch({ type: 'SET_WEATHER', weather: "weather thunder" });
                setWeatherSession("weather thunder");
                break;
            case Weather.HEAVY_RAIN:
            case Weather.HEAVY_SHOWERS:
            case Weather.LIGHT_RAIN:
            case Weather.LIGHT_SHOWERS:
            case Weather.SHOWERS:
            case Weather.STRONG_WINDS_SHOWERS:
            case Weather.PASSING_SHOWERS:
            case Weather.MODERATE_RAIN:
            case Weather.STRONG_WINDS_RAIN:
            case Weather.SNOW_SHOWERS:
            case Weather.WINDY_RAIN:
            case Weather.WINDY_SHOWERS:
                loader.add("./assets/images/components/island/spritesheets/dayOfTheIsland/rainingBG.json")
                dispatch({ type: 'SET_WEATHER', weather: "weather rain" });
                setWeatherSession("weather rain");
                break;
            default:
                dispatch({ type: 'SET_WEATHER', weather: "weather default" });
                setWeatherSession("weather default");
                break;
        }
    }

    const setup = () => setLoading(false);

    const handleSound = () => {
        if (isMute) {
            setIsMute(false);
            HowlerUtils.unMuteGlobalVolume();
            HowlerUtils.playSound('home');
            StudentProfile.setSoundMute(false);
        }

        else {
            setIsMute(true);
            HowlerUtils.muteGlobalVolume();
            HowlerUtils.stopSound('home');
            StudentProfile.setSoundMute(true);
        }

    }

    if (loading) return <Loading />;

    return (
        <>
            {
                homeContext &&
                < HomeContext.Provider value={{ homeContext, dispatch }}>
                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                        <IslandHolder />
                        <ClusterModal selectCluster={selectCluster} studentConsent={studentConsent} />
                        <Fab size="medium"
                            color="primary" className="adventurelearn__soundIcon" onClick={() => handleSound()}>
                            {
                                isMute ? <VolumeOffIcon /> :
                                    <VolumeUpIcon />
                            }

                        </Fab>
                        <div className="adventurelearn__notiIcon">
                            <NotificationPopover />
                        </div>
                        <IslandMenu />
                    </ErrorBoundary>
                </HomeContext.Provider >
            }
        </>
    )
};

export { HomeApp as default }